import axios from "axios";

export async function fetchTagList() {
  return axios.request({
    url: `/r-api/tag`,
    method: "GET",
  });
}
